import { render } from "./ExpensesEdit.vue?vue&type=template&id=90fb5da8&scoped=true"
import script from "./ExpensesEdit.vue?vue&type=script&lang=js"
export * from "./ExpensesEdit.vue?vue&type=script&lang=js"

import "./ExpensesEdit.vue?vue&type=style&index=0&id=90fb5da8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90fb5da8"]])

export default __exports__